module.exports = __webpack_public_path__ + "img/sad-active.70255b30.svg";